import colors from "colors";
import { IconProps } from "./types";

export default function IcoArrowRight({
	color = colors.neutral["low-pure-500"],
	size = "20"
}: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 9H17M17 9L9 17M17 9L9 1"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
